import { render, staticRenderFns } from "./indexs.vue?vue&type=template&id=493fbe62&scoped=true"
import script from "./indexs.vue?vue&type=script&lang=js"
export * from "./indexs.vue?vue&type=script&lang=js"
import style0 from "./indexs.vue?vue&type=style&index=0&id=493fbe62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493fbe62",
  null
  
)

export default component.exports